<div class="mt-5">
  <app-common-table [params]="getTableParams()"></app-common-table>
</div>